export default "__VITE_ASSET__f7ae177e__"